import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { JourneysList } from '../app/components/journey/journeys-list';
import { ProtectedRoute } from '@org/ui';

export const Route = createFileRoute('/journeys')({
  component: JourneysRoute,
});

function JourneysRoute() {
  const navigate = useNavigate({ from: '/journeys' });

  return (
    <ProtectedRoute requiredPermissions={['admin:all', 'journeys:*']}>
      <div className="space-y-6">
        <JourneysList
          onCreateJourney={() => navigate({ to: '/journeys/new' })}
          onEditJourney={(journey) =>
            navigate({ to: '/journeys/$journeyId', params: { journeyId: journey.journeyId } })
          }
        />
        <Outlet />
      </div>
    </ProtectedRoute>
  );
}


